/**
 *
 * @description webview화면 여부를 custom user를 통해 구분
 */
export const isWebview = () => {
	const userAgent = navigator.userAgent.toLowerCase()
	return /android|webos|iphone|ipad|ipod|blackberry|windows phone/.test(userAgent)
}
